<template>
  <div>
    <b-form @keyup.enter="query" onsubmit="return false">
      <el-row>
        <el-col :span="4">
          <el-button-group>
            <el-button @click="add" type="success" size="medium">{{
              this.$l('tips_add') || '添加'
            }}</el-button>
          </el-button-group>
        </el-col>
        <el-col :span="20">
          <el-input
            class="input-with-select"
            placeholder="Search here..."
            size="medium"
            v-model="form.searchKey"
            clearable
          >
            <el-button slot="append" icon="el-icon-search" @click="query">{{
              $l('INDEX.product_dialog_btn_search') || '搜索'
            }}</el-button>
          </el-input>
        </el-col>
      </el-row>
    </b-form>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {
        searchKey: '',
      },
    }
  },
  methods: {
    query() {
      this.$emit('submit', this.form)
    },
    add() {
      this.$emit('chooseGroupAdd')
    },
  },
}
</script>
